import { OperatorsDetail } from '@/model/CommonModel';
import { GraphicStatus, GraphicStudioFilterBy } from '@/model/GraphicModel';
import { Button, Divider, Empty, List, Typography } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Checkbox } from 'antd/lib';
import VirtualList from 'rc-virtual-list';
import React, { FC } from 'react';
import styles from './graphicFilterByContent.module.scss';

const { Text } = Typography;

type Props = {
	filterByData: GraphicStudioFilterBy;
	operators: OperatorsDetail[];
	setFilterByData: (filterData) => void;
	onClearFilterBy: () => void;
	onFilterBy: () => void;
};

const itemHeight: number = 30;
const getVirtualListHeight = (length: number): number => {
	let listHeight = 150;
	if (length <= 5) {
		listHeight = itemHeight * length;
	}

	return listHeight;
};

const GraphicFilterByContent: FC<Props> = ({ filterByData, operators, setFilterByData, onClearFilterBy, onFilterBy }) => {
	const onChangeOperatorName = (e: CheckboxChangeEvent, operator: OperatorsDetail) => {
		if (e.target.checked) {
			setFilterByData(prevState => ({ ...prevState, OperatorNames: [...prevState.OperatorNames, operator] }));
		} else {
			setFilterByData(prevState => ({ ...prevState, OperatorNames: prevState.OperatorNames.filter(x => x.Id !== operator.Id) }));
		}
	};

	const enableApplyFilter = (filterByData.OperatorNames && filterByData.OperatorNames.length > 0) || filterByData.Status !== GraphicStatus.Published;

	return (
		<div className={styles.container}>
			{operators.length > 0 ? (
				<>
					<span>{_('CreatedBy')}:</span>
					<div>
						<div>
							<Checkbox
								checked={filterByData.Status !== GraphicStatus.Published}
								onChange={e =>
									setFilterByData(prevState => ({ ...prevState, Status: e.target.checked ? GraphicStatus.NA : GraphicStatus.Published }))
								}>
								{_('NotPublish')}
							</Checkbox>
						</div>
						<span>{_('CreatedBy')}:</span>
						<List split={false} size='small' className={styles.createdByList}>
							<VirtualList
								data={operators as OperatorsDetail[]}
								height={getVirtualListHeight(operators.length)}
								itemHeight={itemHeight}
								itemKey='id'>
								{(operators: OperatorsDetail, index) => (
									<List.Item key={index}>
										<div>
											<Checkbox
												checked={filterByData.OperatorNames?.find(x => x.Id === operators.Id) !== undefined}
												onChange={e => onChangeOperatorName(e, operators)}>
												<Text className={styles.operatorName} ellipsis={{ tooltip: { title: operators.Name, placement: 'right' } }}>
													{operators.Name}
												</Text>
											</Checkbox>
										</div>
									</List.Item>
								)}
							</VirtualList>
						</List>
					</div>
				</>
			) : (
				<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
			)}
			<Divider className={styles.divider} />
			<div className={styles.footer}>
				<Button onClick={onClearFilterBy}>{_('Reset')}</Button>
				<Button type='primary' onClick={onFilterBy} disabled={!enableApplyFilter}>
					{_('Filter')}
				</Button>
			</div>
		</div>
	);
};

export { GraphicFilterByContent };
